import { gql } from '@grandvisionhq/graphql';
import { productFragment } from './product.js';

const returnsLineItemsFragment = gql`
  fragment ReturnsLineItemsFragment on SlimOrderLineItem {
    quantity
    lineItemNumber
    sku
    isReturnable
    product {
      ...ReturnProductFragment
    }
  }
  ${productFragment}
`;

export { returnsLineItemsFragment };
//# sourceMappingURL=line-item.js.map
